export default __webpack_public_path__ + "static/media/GarretEhlers.ea58212b.jpg";